import ButtonComponent from "./ButtonComponent";
import { getSecureItemFromSpecificStorage, storeSecureItemInSpecifiedStorage } from "../lib/BrowserStorageAccessMiddleware";
import { LOCAL_STORAGE, TXN_ID, LS_CUSTOMER, LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS, SS_REDIRECTED_FROM_LOGIN, LS_DOMAIN_AND_LOCKER_BANK, LS_LOCKER_BANK_INFO, LS_BOOKING_TYPE, ADVANCE_BOOKING, ACCESS_GROUP_BANKS, PERMISSIONS_LIST,  } from "../assets/constants/BrowserStorageKeys";
import { HIVEBOARD, SUCCESS, TOAST_ERROR, TOAST_SUCCESS } from "../assets/constants/Constants";
import { advancereserveLocker, sendOtp, verifyOtp } from "../api/api";
import { useHistory } from 'react-router-dom';
import { getAssignedLockers, GetAvailableLockerSizesAndRedirectUser, getPathForNextPage, handleBulkReservationPayment, handleStoreUserDataInLocalStorage, markUserDetailsDialogShown } from "../lib/Utils";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { HOME, LOGIN, USER_ACCOUNT } from "../assets/constants/PageList";
import ShowToast from "./ToastComponent";
import CircularProgressLoader from "./CircularProgressLoader";
import { useTranslation } from "react-i18next";

const OtpInput = ({ length = 4, userInput , bookingObject ,finalGSTObject }) => {
  const { t } = useTranslation()
  const [otp, setOtp] = useState(new Array(length).fill(""));
  const [timeLeft, setTimeLeft] = useState(60);
  const [status, setStatus] = useState("idle");
  const [otpErrorText, setOtpErrorText] = useState("");
  const [showProgress, setShowProgress] = useState(true);
  const [showTick, setShowTick] = useState(false);
  const [isResendLoading, setIsResendLoading] = useState(false);
  const [isAdvanceProcessing, setIsAdvanceProcessing] = useState(false);
  const [advanceLoaderMessage] = useState(t('msg_please_wait_for_reservation_and_payment'));
  const [isStandardProcessing, setIsStandardProcessing] = useState(false);
  const [standardLoaderMessage] = useState(t('pleaseWaitText'));
  const history = useHistory();
  const inputsRef = useRef([]);
  const assignemntSettings = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS);
  const lockerBankId = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_DOMAIN_AND_LOCKER_BANK)?.lockerBankId;
  const lockerBankInfo = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_LOCKER_BANK_INFO);
  const isPricingEnabled = assignemntSettings?.is_pricing;
  const isOtpExpired = timeLeft <= 0;
  const isProcessing = isAdvanceProcessing || isStandardProcessing;
  const loaderMessage = isAdvanceProcessing ? advanceLoaderMessage : standardLoaderMessage;
 console.log("isPricingEnabled", isPricingEnabled)
  useEffect(() => {
    if (timeLeft <= 0) return;

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  
  const handleChange = async (value, index) => {
    if (!/^\d*$/.test(value)) return;

    if (status !== "idle") {
      setStatus("idle");
      setOtpErrorText("");
      setShowProgress(true);
      setShowTick(false);
    }

    const newOtp = [...otp];
    newOtp[index] = value.slice(-1);
    setOtp(newOtp);

    if (value && index < length - 1) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").replace(/\D/g, "");
    if (!pasted) return;

    const newOtp = [...otp];
    let pasteIndex = 0;

    for (let i = 0; i < length && pasteIndex < pasted.length; i += 1) {
      newOtp[i] = pasted[pasteIndex];
      pasteIndex += 1;
    }

    setOtp(newOtp);
    const nextIndex = Math.min(pasted.length, length) - 1;
    if (nextIndex >= 0) {
      inputsRef.current[nextIndex]?.focus();
    }
  };

  const handleResend = useCallback(async () => {
    try {
      setIsResendLoading(true);
      await new Promise((res) => setTimeout(res, 6000));
      setOtp(new Array(length).fill(""));
      setTimeLeft(60);
      setStatus("idle");
      setShowTick(false);
      setShowProgress(true);
      inputsRef.current[0]?.focus();
      let assignmentSlug = assignemntSettings?.slug;
      if (assignmentSlug && userInput) {
        const response = await sendOtp(userInput, assignmentSlug, true);
        if (response.status === SUCCESS) {
          let txnId = response?.data?.txn_id;
          storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, TXN_ID, txnId);
        } else {

        }
      }
    } catch (error) {
      console.error("Resend Error:", error);
    } finally {
      setIsResendLoading(false);
    }
  }, [length]);


  const progress = (otp.filter((d) => d !== "").length / length) * 100;

  const handleVerifyOtp = async () => {

    try {
        const txn_id = getSecureItemFromSpecificStorage(
          LOCAL_STORAGE,
          TXN_ID
        );

        const otpValue = otp.join("");
        const hasAnyDigit = otp.some((d) => d !== "");
        const isOtpComplete = otp.length === length && otp.every((d) => d !== "");

        if (!hasAnyDigit || !isOtpComplete) {
          setStatus("error");
          setOtpErrorText(t('OTPError'));
          setShowProgress(false);
          setShowTick(false);
          ShowToast(t('OTPError'), TOAST_ERROR);
          const firstEmptyIndex = otp.findIndex((d) => d === "");
          if (firstEmptyIndex >= 0) {
            inputsRef.current[firstEmptyIndex]?.focus();
          } else {
            inputsRef.current[0]?.focus();
          }
          return;
        }

        const response = await verifyOtp(txn_id, otpValue);
        if (response?.status === SUCCESS) {
          setStatus("success");
          setShowProgress(true);
          let userInfo = response.data;
          const permissionsList = userInfo?.permission_list;
          const accessGroupBanks = userInfo?.access_group_banks;
          handleStoreUserDataInLocalStorage(userInfo)

          if(permissionsList){
            storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, PERMISSIONS_LIST, permissionsList);
          }
          if(accessGroupBanks){
            storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, ACCESS_GROUP_BANKS, accessGroupBanks);
          }

          const bookingtype = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_BOOKING_TYPE )
          if(bookingObject && bookingtype === ADVANCE_BOOKING ){
            if(!isPricingEnabled){
              ShowToast(t('msg_success_otp_verified_wait_for_reservation'), TOAST_SUCCESS);
            }else{
              ShowToast(t('msg_success_otp_successfull_wait_for_reservation_and_payment'), TOAST_SUCCESS);
            }
            try {
                  setIsAdvanceProcessing(true);
                  const reserveLockerResponse = await advancereserveLocker(bookingObject);
                  if (reserveLockerResponse?.data?.status === "success") {
                      ShowToast(t('msg_success_Locker_reserved_wait_for_payment'), TOAST_SUCCESS);
                      if (!isPricingEnabled) {
                         ShowToast(t('msg_success_locker_reservation_redirect_to_profile'), TOAST_SUCCESS);
                        history.push(getPathForNextPage(LOGIN, USER_ACCOUNT));
                      } else {
                        await handleBulkReservationPayment(reserveLockerResponse, history,finalGSTObject, { isAdvanceBooking: true });
                      }
                  }
            } catch (error) {
                 console.log("error happend during advance bokking", error)
            } finally {
                setIsAdvanceProcessing(false);
            }
            
            return ;
          }
          else{
          ShowToast(t('msg_success_otp_verified_successfully'), TOAST_SUCCESS);
          setIsStandardProcessing(true);
          try {
            let assignLockerList = await getAssignedLockers(assignemntSettings.id);
            const assigndata = assignLockerList?.data;
            // handle for Hive board
            if (getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_CUSTOMER) === HIVEBOARD) {
                  sessionStorage.setItem(SS_REDIRECTED_FROM_LOGIN, true);
                  history.push(getPathForNextPage(LOGIN, HOME));
                  return;
              }
            else {
                  if (assigndata.length >= 1) {
                      markUserDetailsDialogShown();
                      history.push(getPathForNextPage(LOGIN, HOME));
                  }
                  else {
                    await GetAvailableLockerSizesAndRedirectUser(lockerBankInfo, lockerBankId, userInfo?.id, assignemntSettings?.is_pricing, history);
                  }
            }
          } finally {
            setIsStandardProcessing(false);
          }
          }
		    setShowProgress(false);
        setShowTick(true);
        } else {
          setOtpErrorText(t('msg_wrong_entered_otp'));
          ShowToast(t('msg_invalid_otp'), TOAST_ERROR);
          throw new Error(t('msg_invalid_otp'));
        }
      } catch (error) {
        console.error("OTP Error:", error);

        setStatus("error");
        setShowProgress(true);

        setTimeout(() => {
          setShowProgress(false);
        }, 800);
      }
  }
 
  return (
    <div className="otp-container">
      <div className="otp-left">
        <p className="otp-title">
          {t('enter_otp_sent_to_user_email_or_mobile', {userEmailOrMobile: userInput})}
        </p>
        <div className="otp-group">
          <div className="otp-input-wrapper">
            {otp.map((digit, index) => (
              <input
                key={index}
                type="tel"
                inputMode="numeric"
                pattern="[0-9]*"
                autoComplete="one-time-code"
                maxLength="1"
                value={digit}
                ref={(el) => (inputsRef.current[index] = el)}
                onChange={(e) =>
                  handleChange(e.target.value, index)
                }
                onKeyDown={(e) =>
                  handleKeyDown(e, index)
                }
                onPaste={handlePaste}
                className={`otp-input 
                  ${digit ? "filled" : ""} 
                  ${status === "error" ? "error" : ""} 
                  ${status === "success" ? "success" : ""}`}
              />
            ))}

            {showTick && <span className="otp-success">✔</span>}
          </div>
          {showProgress && (
            <div className="otp-progress">
              <div
                className={`otp-progress-bar 
                  ${status === "success" ? "success" : ""} 
                  ${status === "error" ? "error" : ""}`}
                style={{
                  width:
                    status !== "idle"
                      ? "100%"
                      : `${progress}%`,
                }}
              />
            </div>
          )}
        </div>
        {status === "error" && otpErrorText && (
          <p className="otp-error-text">
            {otpErrorText}
          </p>
        )}
        <p className="otp-timer">
          Code valid for{" "}
          <span className="time">
            0:{timeLeft < 10 ? `0${timeLeft}` : timeLeft}
          </span>
        </p>
      </div>
      <div className="otp-actions">
        {isOtpExpired ? (
          <ButtonComponent
            align="right"
            type="custom"
            title={t('resend_otp_btn')}
            handleClick={handleResend}
            disabled={isResendLoading || isProcessing}
          />
        ) : (
          <ButtonComponent
            align="right"
            type="custom"
            title={t('text_submit_otp')}
            handleClick={handleVerifyOtp}
            disabled={isResendLoading || isProcessing}
          />
        )}
      </div>

      {isProcessing && (
        <CircularProgressLoader message={loaderMessage} />
      )}
    </div>
  );

};




export default OtpInput;
